<script lang="ts">
    import { onMount } from 'svelte';
    import { idPageActualites } from "../scripts/router2";
    import Newsletter from '../components/Newsletter.svelte';
    import ActuInsight from '../components/ActuInsight.svelte';
    import { storeActus, storeEvents } from '../scripts/classes/actu';
    import { redirectTo } from '../scripts/router1';
    import BallsHome from '../components/BallsHome.svelte';
    import NewsletterRegistration from '../components/NewsletterRegistration.svelte';
    import Events from '../components/Events.svelte';

    let nbActus = 6;

    onMount(async () => {
        initNbActus();
        window.scrollTo(0,0);
	});

    function initNbActus() {
        const largeur = window.innerWidth;
        if (largeur < 640) {
            nbActus = 2;
        } else if (largeur < 1400) {
            nbActus = 4;
        } else if (largeur < 1600) {
            nbActus = 6;
        } else {
            nbActus = 8;
        }
    }

</script>
    
<style lang="scss">
    
    .home {
        &__contener {
            margin-top: 100px;
        }
        &__img-mobile {
            margin: 50px 0 0 0;
            z-index: 100;
            width: 90%;
        }
        &__img {
            display: none;
        }
        &__events {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 20px 0 50px 0;
            width: 80%;
        }
        &__actus {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 20px 0 50px 0;
            &__btn {
                margin: -35px 0 0 0;
                background-color: $color_primary;
                height: 70px;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-items: center;
                &__text {
                    padding: 0 20px 0 20px;
                    font-family: 'Borna-Medium';
                    font-size: 19px;
                }
                &__submit {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-around;
                    align-items: center;
                    cursor: pointer;
                    background-image: url('../assets/images/btn_tout_voir.svg');
                    background-repeat: no-repeat;
                    background-size: contain;
                    &:hover {
                        background-image: url('../assets/images/btn_tout_voir_hover.svg');
                    }
                    &__img {
                        opacity: 0;
                        height: 26px;
                        margin: 0 30px 0 0;
                    }
                }
            }
        }
        &__actuinsight {
            margin: 36px 0 0 0;
        }
    }

    .anchorHome {
        display: none;
    }

    @include large {
        .home {
            &__contener {
                margin-top: 100px;
            }
            &__events {
                flex-direction: row;
                min-width: 100%;
                margin: 50px 0 0 0;
            }
            &__actus {
                flex-direction: row;
                min-width: 110%;
                max-width: 110%;
                width: 110%;
                margin: 70px 0 75px 0;
                &__btn {
                    position: absolute;
                    margin: -50px 30px 0 30px;
                    align-self: flex-start;
                }
            }
            &__img-mobile {
                display: none;
            }
            &__img {
                display: block;
                margin: 40px 0 0 0;
                z-index: 100;
                width: 70%;
            }
            &__actuinsight {
                margin: 0 15px 0 15px;
            }
        }
    }

</style>

<div id="anchorHome" class="anchorHome"></div>
<div class="page">
    <img class="home__img-mobile" src="../assets/images/ptce_home_mobile.png" alt="PTCE accueil">
    <img class="home__img" src="../assets/images/ptce_home.png" alt="PTCE accueil">
    {#if $storeEvents.length > 0}
    <div class="page__contener home__contener">
        <div class="home__actus__btn">
            <div class="home__actus__btn__text">Les prochains évènements</div>
        </div>
        <div class="home__events">
            <Events />
        </div>
    </div>
    {/if}
    <div class="page__contener home__contener">
        <div class="home__actus__btn">
            <div class="home__actus__btn__text">les actualités</div>
            <div class="home__actus__btn__submit" on:click={() => redirectTo(idPageActualites)} on:keydown={() => redirectTo(idPageActualites)}>
                <img class="home__actus__btn__submit__img" src="../assets/images/btn_tout_voir.svg" alt="tout voir">
            </div>
        </div>
        <div class="home__actus">
            {#each $storeActus as actu, i}
            {#if (i < nbActus)}
            <div class="home__actuinsight">
                <ActuInsight inActu={actu}/>
            </div>
            {/if}
            {/each}
        </div>
    </div>
    <BallsHome />
    <Newsletter />
    <NewsletterRegistration />
</div>
